var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"mt-2":""}},[_c('v-footer',{attrs:{"color":"#0065BD","fixed":"","dark":"","height":"auto"}},[_c('v-flex',{attrs:{"text-xs-center":"","white--text":"","xs12":""}},[_c('v-btn',{attrs:{"to":{
          name: 'copyright'
        },"flat":"","white--text":""}},[_c('strong',[_vm._v(" ©  2000 –  "+_vm._s(_vm.currYear)+". IDS Publishing Corporation. All rights reserved.")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8412c090","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 